export default __webpack_public_path__ + "static/const-five-5ad2dd75909c1cee7a34eb5c8bf1ecf0.png";